import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { timezoneData } from '../layout/CloudExecution/data';
const initialState = {
  reOrderAble: false,
  isResetDataLoading: false,
  searchCaseOperation: '',
  searchCaseOrder: '',
  searchCaseGantt: '',
  isOrderPlanSelected: false,
  isOpPlanSelected: false,
  planId: 0,
  event_id: 0,
  local_event_id: 0,
  timezone_offset: 0,
  page_range_from_settings: 300,
};
const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    changeReOrderAble: (state, action) => {
      state.reOrderAble = action.payload;
    },
    changeResetDataLoadingBoolenValue: (state) => {
      state.isResetDataLoading = !state.isResetDataLoading;
    },
    setSearchCaseOp: (state, action) => {
      state.searchCaseOperation = action.payload;
    },
    setSearchCaseOrder: (state, action) => {
      state.searchCaseOrder = action.payload;
    },
    setSearchCaseGantt: (state, action) => {
      state.searchCaseGantt = action.payload;
    },
    setIsPlanSelected: (state, action) => {
      state.isOrderPlanSelected = action.payload.isOrderPlanSelected;
      state.isOpPlanSelected = action.payload.isOpPlanSelected;
      state.planId = action.payload.planId;
    },
    setEventId: (state, action) => {
      state.event_id = action.payload;
    },
    setLocalEventId: (state, action) => {
      state.local_event_id = action.payload;
    },
    setTimezoneOffset: (state, action) => {
      state.timezone_offset = action.payload;
    },
    setFetchSize: (state, action) => {
      state.page_range_from_settings = action.payload;
    },
  },
});
export const changeResetDataLoadingBoolenValue =
  searchSlice.actions.changeResetDataLoadingBoolenValue;
export const setSearchCaseOp = searchSlice.actions.setSearchCaseOp;
export const setSearchCaseOrder = searchSlice.actions.setSearchCaseOrder;
export const setSearchCaseGantt = searchSlice.actions.setSearchCaseGantt;
export const setIsPlanSelected = searchSlice.actions.setIsPlanSelected;
export const setEventId = searchSlice.actions.setEventId;
export const setLocalEventId = searchSlice.actions.setLocalEventId;
export const setTimezoneOffset = searchSlice.actions.setTimezoneOffset;
export const setFetchSize = searchSlice.actions.setFetchSize;
export const changeReOrderFunc = searchSlice.actions.changeReOrderAble;
export default searchSlice.reducer;
